import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
  selector: 'loading-overlay',
  templateUrl: 'loading-overlay.component.html',
  styleUrls: ['loading-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LoadingOverlayComponent {
  @Input() loadingLabel = 'Loading...';

  constructor() {
    // noop
  }
}
